import { ArrowLeft } from "lucide-react";

const DashboardInlineBackButton = ({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) => (
  <button
    type="button"
    onClick={onClick}
    className="inline-flex min-h-11 w-fit items-center gap-2 rounded-2xl border border-black/10 bg-white px-4 text-sm font-bold text-primary shadow-sm transition hover:border-secondary/30 hover:bg-secondary/10 hover:text-secondary"
  >
    <ArrowLeft size={18} />
    <span>{label}</span>
  </button>
);

export default DashboardInlineBackButton;
